'use strict';

(
    function($)
    {
        $.fn.dialog = function(active)
        {
            $(this).each
            (
                function()
                {
                    const self = this;

                    function setCenter(width, height, fixHeight = false)
                    {
                        if(fixHeight && $(window).height() <= height)
                        {
                            $(self).find(".dialog__box").css(
                                {
                                    left: Math.floor(($(document).width() / 2) - (width / 2)) + 'px'
                                }
                            );
                        }
                        else
                        {
                            $(self).find(".dialog__box").css(
                                {
                                    left: Math.floor(($(document).width() / 2) - (width / 2)) + 'px',
                                    top: Math.floor($(document).scrollTop() + ($(window).height() - height) / 2) + 'px',
                                }
                            );
                        }
                    }

                    function close()
                    {
                        $(self).find(".dialog__box").next(".dialog__scrim").remove();

                        $(self).trigger("close");

                        $(self).fadeOut(200,
                            function()
                            {
                                $(self).trigger("closed");
                            }
                        );
                    }

                    if(active && $(this).is(":hidden"))
                    {
                        $(this).css("display", "block");
                        const width = $(this).find(".dialog__box").width();
                        const height = $(this).find(".dialog__box").height();
                        $(this).css("display", "none");

                        setCenter(width, height);
                        const isScrim = !!$(this).next('.dialog__scrim').length;

                        if(!isScrim) $(this).append("<div class='dialog__scrim'></div>");

                        $(this).fadeIn(400, function()
                        {
                            setCenter(width, height);
                            $(window).trigger('resize');

                            for(let i = 0; i < 5; i++)
                            {
                                window.setTimeout(() => {
                                    $(window).trigger('resize');
                                }, 500 * i);
                            }
                        });

                        if(!isScrim)
                        {
                            $(this).find(".dialog__close").click(() =>{
                                close();
                            });

                            $(this).find(".dialog__scrim").click(() =>{
                                close();
                            });

                            $(window).on("scroll", () => {
                                if(active && !$(self).is(":hidden"))
                                {
                                    const width = $(self).find(".dialog__box").outerWidth();
                                    const height = $(self).find(".dialog__box").outerHeight();
                                    setCenter(width, height, true);
                                }
                            });

                            $(window).on("resize", () => {
                                if(active && !$(self).is(":hidden"))
                                {
                                    const width = $(self).find(".dialog__box").outerWidth();
                                    const height = $(self).find(".dialog__box").outerHeight();

                                    setCenter(width, height, true);
                                }
                            });
                        }
                    }
                    else if(!active && !$(this).is(":hidden"))
                    {
                        close();
                    }
                }
            );

            return $(this);
        }
    }
)(jQuery);
